<template>
  <v-container v-if="programme">
    <v-card color="grey lighten-4" class="mx-auto" flat hover v-ripple rounded>
      <v-card-title class="d-flex flex-row justify-center">
        <div class="green--text text-h2 font-weight-bold">
          {{ programme ? programme.code : "" }}
        </div>
      </v-card-title>
      <v-card-text class="d-flex flex-row justify-center">
        <div class="font-italic font-weight-medium pb-4">
          {{ programme ? programme.description : "no description" }}
        </div>
      </v-card-text>

      <v-divider class="mx-4 my-n3"></v-divider>

      <v-list color="transparent" dense>
        <v-list-item class="text-lg-h5" dense>
          <v-list-item-title>Programme Information</v-list-item-title>
          <v-list-item-action>
            <v-btn icon @click="show = !show">
              <v-icon>{{
                show ? "mdi-chevron-up" : "mdi-chevron-down"
              }}</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-container flat v-show="show">
          <div class="text-caption">
            <pre>{{
              programme.applicationInformation || "No info provided"
            }}</pre>
          </div>
        </v-container>

        <v-divider class="mx-4 my-n3"></v-divider>

        <v-list-item class="text-lg-h5" dense color="transparent">
          <v-list-item-title>Requirements</v-list-item-title>
          <v-list-item-action>
            <v-btn icon @click="show = !show">
              <v-icon>{{
                show ? "mdi-chevron-up" : "mdi-chevron-down"
              }}</v-icon>
            </v-btn>
          </v-list-item-action>
        </v-list-item>
        <v-container flat v-show="show">
          <v-data-table
            v-if="programme.checklist.length !== 0"
            :headers="headers"
            :items="programme.checklist"
            hide-default-footer
          >
            <!--eslint-disable-next-line -->
                      <template v-slot:item.mandatory="{ item }">
              <v-icon color="primary">
                {{ item.mandatory === true ? "mdi-check-bold" : "" }}
              </v-icon>
            </template>
          </v-data-table>
        </v-container>
        <v-divider class="mx-4 mt-n3 mb-4"></v-divider>
        <v-list-item dense>
          <v-select
            outlined
            autofocus
            dense
            v-if="programme && programme.programmeStages"
            placeholder="Select Intake Stage"
            persistent-placeholder
            prepend-inner-icon="school"
            :items="programme.programmeStages"
            item-text="description"
            v-model="stage"
            :item-value="(item) => item"
          >
            <template v-slot:item="{ item }">
              {{ item.description }}
              <v-chip small class="mx-2">
                {{
                  `Early Bird: ksh ${item.stageCharges
                    .filter((c) => c.newStudentCharge)
                    .reduce((a, b) => a + b.amountEarly, 0)}`
                }}
                <v-divider vertical class="mx-2"></v-divider>
                {{
                  `Regular: ksh ${item.stageCharges
                    .filter((c) => c.newStudentCharge)
                    .reduce((a, b) => a + b.amountRegular, 0)}`
                }}
              </v-chip>
            </template>
          </v-select>
        </v-list-item>
      </v-list>
      <v-card-text
        v-if="
          programme &&
          programme.code === stage.programmeCode &&
          charges.length !== 0
        "
      >
        <v-data-table
          class="mt-n7"
          :headers="chargesHeaders"
          :items="charges"
          hide-default-footer
          dense
        >
          <template v-slot:item="{ item }">
            <tr
              :class="
                item.mandatory ? 'deep-orange lighten-3' : 'blue lighten-3'
              "
            >
              <td>{{ item.code }}</td>
              <td>Ksh {{ item.amountEarly }}</td>
              <td>Ksh {{ item.amountRegular }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <v-card-actions>
        <v-btn
          block
          color="accent"
          :disabled="
            programme &&
            (stage === null || programme.code !== stage.programmeCode)
          "
          outlined
          @click="submit"
        >
          apply
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import { AuthService } from "../../dashboard/modules/auth";
export default {
  name: "AppLanding",
  data() {
    return {
      formData: {
        programme: "",
        stage: "",
        semester: "",
        profileID: "",
      },
      selected: [],
      show: true,
      stage: {},
      headers: [
        { text: "CheckList Type", sortable: false, value: "checkListType" },
        {
          text: "Description",
          sortable: false,
          value: "description",
        },
        { text: "Service Type", sortable: false, value: "serviceType" },
        { text: "Mandatory", value: "mandatory" },
      ],
      chargesHeaders: [
        { text: "#", sortable: true, value: "code" },
        { text: "Amount Early", sortable: true, value: "amountEarly" },
        { text: "Amount Regular", sortable: true, value: "amountRegular" },
      ],
    };
  },
  computed: {
    programme() {
      const programme = this.$store.getters["Application/appGetters"](
        "setupProgrammes",
      ).filter((prog) => prog.code === atob(this.$route.params.app))[0];
      return programme;
    },
    charges() {
      return Object.keys(this.stage).length !== 0
        ? this.stage.stageCharges.filter((c) => c.newStudentCharge)
        : [];
    },
    user() {
      return AuthService.user;
    },
    application() {
      return this.$store.getters["Application/appGetters"]("applications");
    },
  },
  mounted() {
    Event.$on("changeAppStatus", () => {
      this.$router.replace({
        name: "Payments",
        params: {
          app: this.encode(localStorage.getItem("applicationNo")),
        },
      });
    });
  },
  methods: {
    encode(value) {
      return btoa(value);
    },
    submit: function () {
      let applicationNo = localStorage.getItem("applicationNo");
      //semester,stage,programme,profileID
      if (!applicationNo) {
        this.formData.stage = this.stage.code;
        this.formData.semester =
          this.programme["programmeSemester"].shift().semester;
        this.formData.programme = this.programme.code;
        this.formData.profileID = this.user["profile_id"];
        this.$store.dispatch("Application/updateApplication", {
          ...this.formData,
        });
      } else {
        this.$router.push({
          name: "Payments",
          params: { app: this.encode(applicationNo) },
        });
      }
    },
  },
};
</script>
<style scoped>
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  font-family: inherit;
}
</style>
